import { MeasurementSystem } from '../types/MeasurementSystem';
import { MetricConverter } from './helpers';

const LengthMetricUnits = ['mm', 'cm', 'm', 'km'] as const;
const LengthImperialUnits = ['in', 'ft'] as const;
export const LengthUnits = [...LengthMetricUnits, ...LengthImperialUnits] as const;

type TLengthUnitMetric = (typeof LengthMetricUnits)[number];
type TLengthUnitImperial = (typeof LengthImperialUnits)[number];
type TLengthUnit = (typeof LengthUnits)[number];

type LengthUnitForSystem<MSystem extends MeasurementSystem> = MSystem extends MeasurementSystem.METRIC
    ? TLengthUnitMetric
    : MSystem extends MeasurementSystem.IMPERIAL
      ? TLengthUnitImperial
      : never;

export class LengthConverter<MSystem extends MeasurementSystem> extends MetricConverter<
    TLengthUnit,
    TLengthUnitMetric
> {
    baseUnit = 'm' as const;
    units = LengthUnits;
    system: MSystem;

    protected getMultiplier(unit: string) {
        switch (unit) {
            case 'in':
                return 0.0254;
            case 'ft':
                return 0.3048;
            default:
                return super.getMultiplier(unit);
        }
    }

    constructor(measurementSystem: MSystem) {
        super();

        this.system = measurementSystem;
    }

    getDisplayUnits(): LengthUnitForSystem<MSystem>[] {
        switch (this.system) {
            case MeasurementSystem.METRIC:
                return [...LengthMetricUnits] as LengthUnitForSystem<MSystem>[];
            case MeasurementSystem.IMPERIAL:
                return [...LengthImperialUnits] as LengthUnitForSystem<MSystem>[];

            default:
                throw new Error('Invalid measurement system');
        }
    }
}

// Get display units is typed for measurement system
// const metric = new LengthConverter(MeasurementSystem.METRIC);
// metric.getDisplayUnits;

// const imperial = new LengthConverter(MeasurementSystem.IMPERIAL);
// imperial.getDisplayUnits;
